
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    name: String,
    date: String,
    hour: String,
    place: String,
    image: String,
    title: String,
  },
})
export default class GuestCard extends Vue {
  name!: string;
  title!: string;
  label: string = !this.name ? this.title : this.name;
  date!: string;
  hour!: string;
  place!: string;
  image!: string;
}
